import { request } from "utils/request";
import { header } from "utils/auth";
import CrmSettingsApiService from "app/apiService/crm/crmSettingsApiService";

// Function to fetch crm settings from real API
const fetchCRMSettingsFromAPI = async ({ dealershipId }): Promise<any> => {
  console.log(`Fetching crm settings from API... for dealershipId:${dealershipId}`);
  try {
    return await CrmSettingsApiService.getCRMSettings(dealershipId);
  } catch (error) {
    console.error('Error fetching crm settings:', error);
    throw error;
  }
};

// Function to create crm settings from real API
const createCRMSettingsFromAPI = async ({ dealershipId, data }): Promise<any> => {
  console.log(`Creating crm settings from API... for dealershipId:${dealershipId}`);
  try {
    const requestURL = `/api/v2/dealer-settings?dealer=${dealershipId}&type=CRM`;
    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data)
    });

    if (!response) {
      throw new Error('Failed to create crm settings from API');
    }
    CrmSettingsApiService.invalidateCRMSettingsCache(dealershipId);
    return await response;
  } catch (error) {
    console.error('Error creating crm settings:', error);
    throw error;
  }
};


// Function to update crm settings from real API
const updateCRMSettingsFromAPI = async ({ dealershipId, settingsId, data }): Promise<any> => {
  console.log(`Updating crm settings from API... for dealershipId:${dealershipId}`);
  try {
    const requestURL = `/api/v2/dealer-settings/${settingsId}?dealer=${dealershipId}`;
    const response: any = await request(requestURL, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data)
    });

    if (!response) {
      throw new Error('Failed to update crm settings from API');
    }
    CrmSettingsApiService.invalidateCRMSettingsCache(dealershipId);
    return await response;
  } catch (error) {
    console.error('Error updating crm settings:', error);
    throw error;
  }
};

// Function to delete crm settings from real API
const deleteCRMSettingsFromAPI = async ({ dealershipId, settingsId }): Promise<any> => {
  console.log(`Updating crm settings from API... for dealershipId:${dealershipId}`);
  try {
    const requestURL = `/api/v2/dealer-settings/${settingsId}?dealer=${dealershipId}`;
    const response: any = await request(requestURL, {
      method: 'DELETE',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to delete crm settings from API');
    }
    return await response;
  } catch (error) {
    console.error('Error deleting crm settings:', error);
    throw error;
  }
};

// Function to fetch crm dealers from real API
const fetchCRMDealersFromAPI = async ({ dealershipId, data }): Promise<any> => {
  console.log(`Fetching crm dealers from API... for dealershipId:${dealershipId}`);
  try {
    const requestURL = `/api/v1/superuser/crm_settings/get_dealers`;
    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data)
    });

    if (!response) {
      throw new Error('Failed to fetch crm dealers from API');
    }
    return await response;
  } catch (error) {
    console.error('Error fetching crm dealers:', error);
    throw error;
  }
};

// Function to fetch crm users from real API
const fetchCRMUsersFromAPI = async ({ dealershipId, data }): Promise<any> => {
  console.log(`Fetching crm users from API... for dealershipId:${dealershipId}`);
  try {
    const requestURL = `/api/v1/superuser/crm_settings/get_users`;
    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data)
    });

    if (!response) {
      throw new Error('Failed to fetch crm dealers from API');
    }
    return await response;
  } catch (error) {
    console.error('Error fetching crm dealers:', error);
    throw error;
  }
};


// Function to setup totp from real API
const setupTotpFromAPI = async ({ dealershipId, data }): Promise<any> => {
  console.log(`Totp setup from API... for dealershipId:${dealershipId}`);
  try {
    const requestURL = `/api/v1/setupTOTP`;
    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        Authorization: header(),
      }),
      body: data
    });

    if (!response) {
      throw new Error('Failed to setup totp from API');
    }
    return await response;
  } catch (error) {
    console.error('Error setting totp:', error);
    throw error;
  }
};

// Function to fetch totp from real API
const fetchTotpFromAPI = async ({ dealershipId, data }): Promise<any> => {
  try {
    const requestURL = `/api/v1/getTOTP`;
    const bodyToSend = JSON.stringify(data);

    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: bodyToSend
    });

    if (!response) {
      throw new Error('Failed to fetch totp from API');
    }
    return await response;
  } catch (error) {
    console.error('❌ Error fetching totp:', error);
    throw error;
  }
};


// Function to fetch crm settings 
export const fetchCRMSettings = async ({
  dealershipId,
}): Promise<any> => {
  return fetchCRMSettingsFromAPI({ dealershipId });
};

// Function to create crm settings 
export const createCRMSettings = async ({
  dealershipId,
  data
}): Promise<any> => {
  return createCRMSettingsFromAPI({ dealershipId, data });
};

// Function to update crm settings 
export const updateCRMSettings = async ({
  dealershipId,
  settingsId,
  data
}): Promise<any> => {
  return updateCRMSettingsFromAPI({ dealershipId, settingsId, data });
};

// Function to delete crm settings 
export const deleteCRMSettings = async ({
  dealershipId,
  settingsId,
}): Promise<any> => {
  return deleteCRMSettingsFromAPI({ dealershipId, settingsId, });
};

// Function to fetch crm dealers 
export const fetchCRMDealers = async ({
  dealershipId,
  data
}): Promise<any> => {
  return fetchCRMDealersFromAPI({ dealershipId, data });
};

// Function to fetch crm dealers 
export const fetchCRMUsers = async ({
  dealershipId,
  data
}): Promise<any> => {
  return fetchCRMUsersFromAPI({ dealershipId, data });
};

// Function to set totp 
export const setupTotp = async ({
  dealershipId,
  data
}): Promise<any> => {
  return setupTotpFromAPI({ dealershipId, data });
};

// Function to fetch totp 
export const fetchTotp = async ({
  dealershipId,
  data
}): Promise<any> => {
  return fetchTotpFromAPI({ dealershipId, data });
};


